import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
const PhoneNumber = (props) => {
  // }, [props.initValue]);

  return (
    <PhoneInput
      buttonStyle={{}}
      country={props.countryCode}
      specialLabel={props.specialLabel ? props.specialLabel : "Phone"}
      value={props.initValue}
      name={props.fieldName}
      countryCodeEditable={false}
      onChange={(phone, countryData, event, formatedValue) =>
        props.onChange(phone, countryData, event, formatedValue)
      }
      disabled={props.disabled ? props.disabled : false}
    />
  );
};

export default PhoneNumber;
